import * as React from "react";

import ErrorLoading from "@khan/component-screens/error-loading";
import FullPageSpinner from "@khan/component-screens/full-page-spinner";
import {redirect, useLocation} from "@khan/urls";

import {useApolloGqlClient} from "~/data-access/gql/use-apollo-gql-client.ts";

import {logout} from "./logout-utils.ts";

export default function Logout() {
    const location = useLocation();
    const {gqlClient} = useApolloGqlClient();
    const [error, setError] = React.useState(false);

    React.useEffect(() => {
        let mounted = true;

        const params = location.queryParams;
        const logoutOptions = {
            finish: params.finish === "1" || false,
            continueUrl: params.continue || "",
            allowClever: params.allowClever === "1" || false,
        } as const;

        logout(gqlClient, logoutOptions)
            .then((continueUrl) => {
                if (mounted) {
                    redirect(continueUrl);
                }
            })
            .catch(() => {
                // If something goes wrong in the logout mutation
                // we'll still reach the code above and navigate
                // to the continue URL. This catch is just in case
                // something goes wrong processing the mutation result
                if (mounted) {
                    setError(true);
                }
            });

        return () => {
            mounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- We intentionally want to run this only on mount
    }, []);

    if (error) {
        return <ErrorLoading />;
    }

    return <FullPageSpinner />;
}
